import { c as _c } from "react/compiler-runtime";
import { cx } from "@/lib/tailwind-utils";
import { Category } from "@/types/category";
import { PublicServiceDetail } from "@/types/service";
export const PROMOTION_CATEGORY_NAME = "Promotions";
const promotionSurfaceClasses = cx("border-primary bg-background text-foreground-secondary", "md:hover:bg-row-hover");
export const promotionCategoryAccordionItemClassName = "border-primary ring-1 ring-primary/30";
export const promotionCategoryAccordionHeaderClassName = cx(promotionSurfaceClasses, "*:text-foreground");
export const promotionCategoryBadgeClassName = cx(promotionSurfaceClasses, "inline-flex items-center rounded-full border px-2 py-0.5 text-caption font-semibold");
export function PromotionCategoryBadge() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <span className={promotionCategoryBadgeClassName}>Promotion</span>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
export function isPromotionService(service: PublicServiceDetail): boolean {
  // On an event link every service is the event's; an event price isn't a
  // separate offer to group apart.
  if (service.isEventPrice) return false;
  return !!service.promotionId || !!service.promotionName;
}
export function hasPromotionServices(services: PublicServiceDetail[] | undefined): boolean {
  return services?.some(isPromotionService) ?? false;
}
export function isPromotionCategoryName(category: string | undefined): boolean {
  return category === PROMOTION_CATEGORY_NAME;
}
export function hasRealPromotionCategory(categories: Category[] | undefined): boolean {
  return categories?.some(category => category.name === PROMOTION_CATEGORY_NAME) ?? false;
}
export function isSyntheticPromotionCategoryName(category: string | undefined, categories: Category[] | undefined): boolean {
  return isPromotionCategoryName(category) && !hasRealPromotionCategory(categories);
}
export function withPromotionCategory(categories: Category[] | undefined, services: PublicServiceDetail[] | undefined): Category[] {
  const baseCategories = categories ?? [];
  if (!services?.some(isPromotionService)) return baseCategories;
  if (hasRealPromotionCategory(baseCategories)) {
    return baseCategories;
  }
  return [{
    name: PROMOTION_CATEGORY_NAME,
    description: "Promotions available",
    displayOrder: -1
  }, ...baseCategories];
}
export function getPromotionCategoryAccordionItemClassName(categoryId: string) {
  return isPromotionCategoryName(categoryId) ? promotionCategoryAccordionItemClassName : undefined;
}
export function getPromotionCategoryAccordionHeaderClassName(categoryId: string) {
  return isPromotionCategoryName(categoryId) ? promotionCategoryAccordionHeaderClassName : undefined;
}